/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'groups';
const componentName = 'string-group-list';

const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const numberOfStringsLabel = `${prefix}.numberOfStringsLabel`;

export const ENGLISH = {
    [headerLabel]: 'String Groups',
    [numberOfStringsLabel]: 'Number of Strings',
};
